var map = {
	"./base": 119,
	"./base.vue": 119,
	"./birthday": 297,
	"./birthday.vue": 297,
	"./donate": 298,
	"./donate.vue": 298,
	"./phapa": 299,
	"./phapa.vue": 299,
	"./special-events": 300,
	"./special-events.vue": 300
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 816;


//////////////////
// WEBPACK FOOTER
// ./src/components/templates/products ^\.\/.*$
// module id = 816
// module chunks = 1